import styled from 'styled-components';
import { darken } from 'polished';

export const ButtonContainer = styled.button`
  text-align: center;
  display: flex;
  align-items: center;
  background: ${(props) => props.theme.colors.secondary};
  margin: 10px 0;
  color: #fff;
  height: 36px;
  padding: 0 15px;
  font-weight: bold;
  border: 0;
  border-radius: 4px;
  font-size: 16px;
  transition: background 0.2s;

  &:hover {
    background: ${(props) => darken(0.2, props.theme.colors.secondary)};
  }

  svg {
    margin-right: 6px;
  }
`;
